<template>
  <div class="content">
    <div class="bannerWrap">
      <div class="EC_width"
           style="position: relative">
        <div class="signWrap">
          <span class="signText">全部课程</span>
        </div>
      </div>
      <div class="item_list_wrap">
        <div class="display_between marginBottom40">
          <div class="fontBold">
            学习对象：
          </div>
          <div class="flex1">
            <span class="btnList activeBtn">全部</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
          </div>
        </div>
        <div class="display_between marginBottom40">
          <div class="fontBold">
            学习内容：
          </div>
          <div class="flex1">
            <span class="btnList activeBtn">全部</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
          </div>
        </div>
        <div class="display_between marginBottom40">
          <div class="fontBold">
            授课专家：
          </div>
          <div class="flex1">
            <span class="btnList activeBtn">全部</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
            <span class="btnList">全科医生</span>
          </div>
        </div>
      </div>
      <div class="blockD display_between">
        <div>
          <a href="javascript:;"
             class="gl_pad_btn gl_pad_btn_active marginLeft10">全部</a>
          <a href="javascript:;"
             class="gl_pad_btn marginLeft10">单课程</a>
          <a href="javascript:;"
             class="gl_pad_btn marginLeft10">专栏</a>
          <a href="javascript:;"
             class="gl_pad_btn marginLeft10">大专栏</a>
        </div>
        <div class="rightTag">
          <span class="redColor">最新</span>
          <span>最热</span>
          <span>限时折扣</span>
        </div>
      </div>
    </div>
    <div class="EC_width">
      <div class="display_between marginTop20"
           v-for="(item,index) in apiData"
           :key="index">
        <div class="pub_square"
             v-for="(itemn,indexn) in item"
             :key="indexn">
          <div class="pubs_img">
            <img :src="itemn.img">
          </div>
          <div class="pubs_body">
            <div class="pubs_title">
              {{itemn.title}}
            </div>
            <div class="pubs_label display_between">
              <div>
                <span v-for="(itemx,indexX) in itemn.sign"
                      :key="indexX">{{itemx}}</span>
              </div>
              <div class="pubs_cancel">
                取消收藏
              </div>
            </div>
            <div class="display_between">
              <div class="pubs_tip">
                <span class="redColor">{{itemn.price}}</span>
              </div>
              <div class="pubs_rentou">
                <img src="/image/geren/ren.png">{{itemn.num}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination></pagination>
    </div>
  </div>
</template>

<script>
import lodash from "lodash"
export default {
  name: "qkallCourse",
  data () {
    return {
      apiData: []
    }
  },
  created () {
    this.getData()

  },
  methods: {
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        var usedata = data.qkallCourse.data;
        that.apiData = lodash.chunk(usedata, 4);
      })
    },
  }
}
</script>

<style scoped>
.content {
    flex: 1;
}
.bannerWrap {
    background: #f3f5f6;
    height: 355px;
    position: relative;
    margin-bottom: 80px;
}
.blockD {
    box-sizing: border-box;
    padding-top: 35px;
    padding-left: 45px;
    padding-right: 45px;
    background: #fff;
    width: 1240px;
    position: absolute;
    bottom: 0;
    left: 330px;
}
.rightTag span {
    margin-left: 10px;
    cursor: pointer;
}
.btnList {
    display: inline-block;
    line-height: 32px;
    padding: 0 8px;
    cursor: pointer;
}
.activeBtn {
    color: #df0018;
    background: #f2ebed;
    border-radius: 6px;
}
.item_list_wrap {
    width: 1240px;

    margin: 0 auto;
    padding-top: 40px;
}
.signWrap {
    position: absolute;
    right: 0;
    top: 26px;
}
.signText {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
}
</style>
